import { object } from 'yup';

export function validationSchemaAddGuarantorForm() {
    return object().shape({}).nullable();
}

export const defaultValuesAddGuarantorForm = {};
